import { z } from 'zod'
import { isHtmlEmpty } from '~/utils'

export const bulkProcessSchema = z
  .object({
    action: z.enum(['decline', 'integrate', 'integrate_accept']),
    orderStatus: z.string().optional(),
    note: z.string().optional(),
    sendEmail: z.boolean(),
    templateId: z.number().optional(),
    emailSubject: z.string().optional(),
    emailContent: z.string().optional()
  })
  .refine(
    (data) =>
      data.action !== 'integrate_accept' ||
      (data.orderStatus ?? '').trim() !== '',
    {
      message: 'Le statut de commande est requis',
      path: ['orderStatus']
    }
  )
  .refine(
    (data) => !data.sendEmail || (data.emailSubject ?? '').trim() !== '',
    {
      message: "Le sujet de l'email est requis",
      path: ['emailSubject']
    }
  )
  .refine((data) => !data.sendEmail || !isHtmlEmpty(data.emailContent), {
    message: "Le contenu de l'email est requis",
    path: ['emailContent']
  })

export type BulkProcessFormValues = z.infer<typeof bulkProcessSchema>
